<template>
  <div>
    <el-card
      v-if="showFields.length > 0"
      class="mb-xl"
    >
      <h3 slot="header">Thông tin hiển thị:</h3>
      <el-row
        v-for="f in showFields"
        :key="f.key"
        type="flex"
        align="start"
        class="flex-wrap mb-m"
        :gutter="12"
      >
        <el-col
          :lg="8"
          :span="24"
          class="column-field first"
          style="font-size: 16px;"
        >
          <h3>{{ f.label || f.name }}:</h3>
        </el-col>
        <el-col
          :lg="16"
          :span="24"
          class="column-field last"
          style="font-size: 16px;"
        >
          <ViewItem
            :field="f"
            :data="item"
          />
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="12">
      <el-col
        :lg="12"
        :span="24"
      >
        <el-card
          v-if="updateFields.length > 0"
          class="mb-xl"
        >
          <h3 slot="header">Thông tin cập nhật:</h3>
          <el-form
            ref="updateForm"
            :model="updateForm"
            size="medium"
            label-position="top"
          >
            <el-row
              type="flex"
              align="start"
              class="flex-wrap"
              :gutter="12"
            >
              <el-col
                v-for="field in updateFields"
                :key="field.key"
                :lg="columnByField(field)"
                :span="24"
              >
                <FormItem
                  :form="updateForm"
                  :field="field"
                  :disabled="disabled"
                  :modules="configModules"
                  size="medium"
                />
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
      <el-col
        :lg="12"
        :span="24"
      >
        <el-card>
          <h3 slot="header">Thông tin truy vết:</h3>
          <el-form
            ref="form"
            :model="form"
            size="medium"
            label-position="top"
          >
            <el-row
              type="flex"
              align="start"
              class="flex-wrap"
              :gutter="12"
            >
              <el-col
                :lg="24"
                :span="24"
              >
                <el-form-item
                  prop="notes"
                  label="Ghi chú"
                >
                  <el-input
                    v-model="form.notes"
                    :disabled="disabled"
                    placeholder="Nhập ghi chú"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form
            v-if="logFields.length > 0"
            ref="logForm"
            :model="logForm"
            size="medium"
            label-position="top"
          >
            <el-row
              type="flex"
              align="start"
              class="flex-wrap"
              :gutter="12"
            >
              <el-col
                v-for="field in logFields"
                :key="field.key"
                :lg="columnByField(field)"
                :span="24"
              >
                <FormItem
                  :form="logForm"
                  :field="field"
                  :disabled="disabled"
                  :modules="configModules"
                  size="medium"
                />
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewItem from "@/components/items/ViewItem.vue";
import FormItem from "@/components/items/FormItem.vue";
import constants from "@/config/constants";

export default {
  name: "ApproveForm",
  components: {
    ViewItem,
    FormItem
  },
  props: {
    item: Object,
    disabled: Boolean,
    form: Object,
    updateFields: Array,
    updateForm: Object,
    showFields: Array,
    logFields: Array,
    logForm: Object,
    configModules: Array
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE
    };
  },
  computed: {
  },
  methods: {
    columnByField(field) {
      if ([
        this.fieldType.TEXT,
        this.fieldType.NUMBER,
        this.fieldType.DATE,
        this.fieldType.DATETIME,
        this.fieldType.DATE,
        this.fieldType.DATE,
      ].includes(field.type)) {
        return 12
      }
      return 24
    }
  },
};
</script>

<style lang="scss">
.column-field {
  border: 1px solid #828282;
  padding: 12px 12px;
  border-radius: 4px;
  &.first {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  &.last {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
